import { Injectable } from '@angular/core';

import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';

import { ConfigurationDataService } from './configuration-data.service';
import { HttpCacheService } from './http-cache.service';

@Injectable({
  providedIn: 'root'
})
export class ConfigurationService {

  private readonly CACHE_KEY = 'CONFIGURATION';
  private readonly CACHE_TTL = 3600;

  constructor(
    private configurationDataService: ConfigurationDataService,
    private httpCacheService: HttpCacheService
  ) { }

  // Call the web service to get configuration for the key
  getItem(key): Observable<any> {
    return this.readValue(key);
  }

  readAll(prefix): Observable<any> {
    const cacheKey = this.buildCacheKey(prefix, 'PREFIX');
    const cached = this.httpCacheService.get(cacheKey);
    if (cached !== null) {
      return of(cached);
    }
    return this.configurationDataService.readAll(prefix)
      .pipe(tap((value) => this.httpCacheService.set(cacheKey, value, this.CACHE_TTL)));
  }

  readValue(key): Observable<any> {
    const cacheKey = this.buildCacheKey(key, 'VALUE');
    const cached = this.httpCacheService.get(cacheKey);
    if (cached !== null) {
      return of(cached);
    }
    return this.configurationDataService.readValue(key)
      .pipe(tap((value) => this.httpCacheService.set(cacheKey, value, this.CACHE_TTL)));
  }

  private buildCacheKey(value: string, scope: string): string {
    return `${this.CACHE_KEY}_${scope}_${value}`;
  }
}
